import { Rocket, Check, ArrowRight, Zap, Send, MessageCircle, TrendingUp } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export default function UpgradePrompt({ feature = '', onClose }) {
  const navigate = useNavigate();

  const BENEFITS = [
    'System tworzy posty, które przyciągają klientów',
    'Automatyczna publikacja w odpowiednich grupach',
    'Klienci trafiają do jednego panelu',
    'Gotowe odpowiedzi na wiadomości',
    'Widzisz ile zarabiasz',
  ];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm" onClick={onClose}>
      <div
        className="bg-white rounded-3xl shadow-2xl max-w-md w-full mx-4 overflow-hidden"
        onClick={e => e.stopPropagation()}
        data-testid="upgrade-prompt"
      >
        {/* Header */}
        <div className="bg-gradient-to-br from-[#F47A3B] to-[#E06A2B] p-6 text-white text-center">
          <div className="w-14 h-14 rounded-2xl bg-white/20 backdrop-blur flex items-center justify-center mx-auto mb-3">
            <Rocket className="w-7 h-7" />
          </div>
          <h2 className="text-xl font-extrabold">Masz gotowy system — uruchom go</h2>
          {feature && (
            <p className="text-white/80 text-sm mt-1">
              Aby korzystać z {feature} — aktywuj konto
            </p>
          )}
        </div>

        {/* Value props */}
        <div className="p-6">
          <div className="flex items-center gap-3 mb-4">
            {[
              { icon: Send, color: 'text-blue-500', label: 'Publikuje' },
              { icon: MessageCircle, color: 'text-emerald-500', label: 'Odpowiada' },
              { icon: TrendingUp, color: 'text-[#F47A3B]', label: 'Sprzedaje' },
            ].map((item, i) => (
              <div key={i} className="flex-1 text-center p-2 rounded-xl bg-zinc-50">
                <item.icon className={`w-4 h-4 ${item.color} mx-auto mb-1`} />
                <span className="text-[10px] font-semibold text-zinc-600">{item.label}</span>
              </div>
            ))}
          </div>

          <ul className="space-y-2.5 mb-5">
            {BENEFITS.map((b, i) => (
              <li key={i} className="flex items-center gap-2.5 text-[13px] text-zinc-700">
                <Check className="w-4 h-4 text-emerald-500 flex-shrink-0" />
                {b}
              </li>
            ))}
          </ul>

          <div className="flex items-center gap-2 px-3 py-2 rounded-xl bg-[#F47A3B]/5 border border-[#F47A3B]/15 mb-5">
            <Zap className="w-3.5 h-3.5 text-[#F47A3B] flex-shrink-0" />
            <p className="text-[12px] font-bold text-[#F47A3B]">Średnio: 5–15 zapytań / miesiąc</p>
          </div>

          <Button
            onClick={() => navigate('/panel/subskrypcja')}
            className="w-full bg-[#F47A3B] hover:bg-[#E06A2E] rounded-xl h-12 text-[15px] font-bold text-white shadow-lg shadow-[#F47A3B]/25"
            data-testid="upgrade-btn"
          >
            Zacznij zdobywać klientów
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>

          <button
            onClick={onClose}
            className="w-full text-center mt-3 text-sm text-zinc-400 hover:text-zinc-600 transition-colors"
            data-testid="upgrade-dismiss"
          >
            Nie teraz
          </button>
        </div>
      </div>
    </div>
  );
}
